import { FC, useContext } from "react"

/** Components */
import { SideRailContext } from "../../SideRail/SideRailContext"
/** Types */
import { CSVExportFormData, iEmployee, iWorkRuleSet, tProject } from "../../../cached-data/types"
import { ResourceObject } from "../../../dashboard-data/types"
import { RowNode } from "ag-grid-community"

type Props = {
    data:
        | ResourceObject<tProject>
        | ResourceObject<iEmployee>
        | ResourceObject<CSVExportFormData>
        | ResourceObject<iWorkRuleSet>
    node: RowNode
    flow:
        | "PROJECT_MODIFY"
        | "GROUP_MODIFY"
        | "EMPLOYEE_MODIFY"
        | "MODIFY_CSV_EXPORT"
        | "EMPLOYEE_MODIFY_WITH_TABS"
        | "WORK_RULE_SETS_MODIFY"
    disabled?: boolean | ((data: any) => boolean)
}

export const ModifyButtonCellRenderer: FC<Props> = props => {
    const { flow, data, disabled } = props
    const { enableSideRail } = useContext(SideRailContext)
    const itemId = data.id
    const startModifyFlow = () => {
        if (flow === "PROJECT_MODIFY") {
            if (itemId) enableSideRail({ flow, projectData: data as ResourceObject<tProject> })
        } else if (flow === "GROUP_MODIFY") {
            // Typescript doesn't know we have an itemID if we got here, so checking again
            if (itemId) enableSideRail({ flow, groupId: itemId })
        } else if (flow === "EMPLOYEE_MODIFY" || flow === "EMPLOYEE_MODIFY_WITH_TABS") {
            if (itemId) {
                enableSideRail({ flow, employeeData: data as ResourceObject<iEmployee> })
            }
        } else if (flow === "MODIFY_CSV_EXPORT") {
            if (itemId) {
                enableSideRail({ flow, csvExportData: data as ResourceObject<CSVExportFormData> })
            }
        } else if (flow === "WORK_RULE_SETS_MODIFY") {
            if (itemId) {
                // For whatever reason, the data parameter is stale when the button is clicked,
                // so we need to use the node data instead
                enableSideRail({ flow, workRulesSetData: props.node.data as ResourceObject<iWorkRuleSet> })
            }
        }
    }

    if (flow === "GROUP_MODIFY" && !itemId) {
        // Unlike Project Modify, Group Modify requires an existing group
        // So no button until a group ID is available.
        return <></>
    }
    const isDisabled = disabled ? (typeof disabled === "function" ? disabled({ data }) : disabled) : false
    return (
        <button onClick={startModifyFlow} type="button" className="action-button" disabled={isDisabled}>
            <div>Modify</div>
        </button>
    )
}

export default ModifyButtonCellRenderer
